import { render } from "./Error500.vue?vue&type=template&id=0731cf28"
const script = {}

import "./Error500.vue?vue&type=style&index=0&id=0731cf28&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__